var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "pen_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M4.5 15.5h1.063l7.812-7.813-1.063-1.062L4.5 14.438V15.5ZM3.754 17a.735.735 0 0 1-.535-.215.715.715 0 0 1-.219-.531v-1.81c0-.199.035-.388.104-.569.07-.18.18-.347.333-.5l9.938-9.938A1.444 1.444 0 0 1 14.435 3c.196 0 .384.035.565.104.18.07.347.18.5.333L16.563 4.5c.152.153.263.32.333.5s.104.365.104.553c0 .2-.035.392-.105.574-.07.181-.18.348-.332.498l-9.938 9.938c-.153.152-.32.263-.499.333a1.56 1.56 0 0 1-.567.104H3.754Zm9.08-9.834-.521-.541 1.062 1.063-.54-.522Z"
  }))));
};
export default SvgPen;